import React, { Component } from 'react';
import PropTypes from 'prop-types';

class TableSessionCreatedBy extends Component {
    constructor(props) {
        super(props);

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

    }

    componentWillUnmount() {

    }

    render() {
        const { billReportUsers } = this.props.app.state
        const { tableSession = {}, } = this.props
        if (!billReportUsers.length) {
            return null
        }

        let merchantAdmin = billReportUsers.find(user => user.id == tableSession.merchant_admin_id)
        if (!merchantAdmin) {
            return null
        }

        return (
            <div>
                <strong>{lang.order_by}: {merchantAdmin.name}</strong>
            </div>
        );
    }
}

TableSessionCreatedBy.propTypes = {

};

export default TableSessionCreatedBy;